import { Route } from '@/app/router'
import AuthenticatedMiddleware from '@middleware/Authenticated'

import DasboardView from '@views/Dashboard/DashboardView'

const routes = require.context('@/views', true, /route(|s).js$/)

export default [
	new Route('/', DasboardView).middlewares([AuthenticatedMiddleware]).children([
		new Route('/').redirect('/home'),
		...getRoutesFromContextByDir(routes, 'Dashboard')
	])
]

function getRoutesFromContextByDir (context, dir) {
	let routesToRegister = []
	context.keys().forEach(route => {
		const regexp = new RegExp(dir)
		if (route.match(regexp)) {
			const _route = routes(route).default
			if (_route) {
				if (Array.isArray(_route)) {
					routesToRegister = routesToRegister.concat(_route)
				} else {
					routesToRegister.push(_route)
				}
			}
		}
	})
	return routesToRegister
}
